import PaypalCheckoutButton from './PaypalCheckoutButton';

import compose from 'recompose/compose';
import withHandlers from 'recompose/withHandlers';
import withState from 'recompose/withState';
import lifecycle from 'recompose/lifecycle';

import withCountry from 'src/client/js/view/hocs/withCountry';
import withErrorTranslations from 'src/client/js/view/hocs/withErrorTranslations';
import injectScript from 'src/common/utils/injectScript';
import linkFactory from 'src/client/js/analytics/factory/link';
import { buildPaypalSdkUrl, createPaypalSession, completePayment } from './helpers';

import logger from 'src/logger';

const paymentMethodName = 'paypal_checkout';
const enhance = compose(
  withState('isSubmitting', 'setIsSubmitting'),
  withErrorTranslations,
  withCountry,
  withHandlers({
    completePayment: props => async (data) => {
      return await props.handlePaymentSubmission((async () => {
        props.setIsSubmitting(true);
        try {
          return await completePayment(paymentMethodName, data.orderID, data.payerID, props.country);
        } catch (err) {
          logger.warn(err, `failed processing paypal checkout for order ${data.orderID}`);
          props.sendErrorMessage(error => error.payment.order);
          props.setSubmittingMethod(null);
          props.setIsSubmitting(false);
        }
      }));
    },
    submitPayment: _props => async () => {
      try {
        return await createPaypalSession(paymentMethodName);
      } catch (error) {
        logger.error('Error when confirming paypal checkout session to backend', error);
        return error;
      }
    },
  }),
  lifecycle({
    componentDidMount() {
      const { country: { locale, currency }, settings: { client_id: clientId }, ...props } = this.props;
      // Setting the URL to include clientId, currency, and locale (i.e en_US, with underscore).
      injectScript(
        buildPaypalSdkUrl(
          clientId,
          locale,
          currency),
        () => {
          // eslint-disable-next-line new-cap
          window.paypal.Buttons({
            style: {
              layout: 'horizontal',
              tagline: false,
              size: 'responsive'
            },
            createOrder: props.submitPayment,
            onApprove: props.completePayment,
            onClick:
              linkFactory({
                category: 'Cart',
                action: 'Pay With PayPal Checkout',
                label: 'PayPal Checkout' }),
            // onShippingChange: props.updateShippingAddress, // DOCS if implementing: https://developer.paypal.com/docs/checkout/integration-features/shipping-callback/
          }).render('#paypal-buttons-container');
        });
    },
  })
);

export default enhance(PaypalCheckoutButton);



// WEBPACK FOOTER //
// ./src/client/js/view/components/PaymentMethods/PaymentButton/PaypalCheckoutButton/index.js